"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var readable_node_1 = require("./readable-node");
var interpreter_utils_1 = require("../../interpreter-utils");
var control_model_1 = require("./control-model");
var form_title_model_1 = require("./form-title-model");
var lodash_1 = require("lodash");
var FormLayoutModel = /** @class */ (function (_super) {
    __extends(FormLayoutModel, _super);
    function FormLayoutModel(category, formName, content, header, footer, title, moduleKeys, subwayMap) {
        var _this = _super.call(this) || this;
        _this.category = category;
        _this.formName = formName;
        _this.content = content;
        _this.header = header;
        _this.footer = footer;
        _this.title = title;
        _this.moduleKeys = moduleKeys;
        _this.subwayMap = subwayMap;
        return _this;
    }
    FormLayoutModel.fromJSON = function (value, category) {
        var formLayoutModel = Object.keys(interpreter_utils_1.getRequiredProperty(value, 'forms')).map(function (formName) {
            return new FormLayoutModel(category, formName, interpreter_utils_1.getRequiredProperty(value, "forms." + formName + ".content.grid"), interpreter_utils_1.getOptionalProperty(value, "forms." + formName + ".header.control", undefined, function () { return interpreter_utils_1.getOptionalProperty(value, "forms." + formName + ".header.grid"); }), interpreter_utils_1.getOptionalProperty(value, "forms." + formName + ".footer.grid"), interpreter_utils_1.getOptionalProperty(value, "forms." + formName + ".title", new form_title_model_1.FormTitleModel([])), interpreter_utils_1.getOptionalProperty(value, "moduleKeys", undefined), interpreter_utils_1.getOptionalProperty(value, "forms." + formName + ".subwayMap.control", undefined));
        })[0];
        return formLayoutModel;
    };
    FormLayoutModel.emptyModel = function (formJson, categoryName) {
        return new FormLayoutModel(categoryName, formJson.formSystemName, undefined, undefined, undefined, new form_title_model_1.FormTitleModel([]));
    };
    FormLayoutModel.prototype.toJSON = function () {
        return _a = {},
            _a[this.category] = {
                forms: (_b = {},
                    _b[this.formName] = {
                        content: { grid: this.content },
                        header: this.header instanceof control_model_1.ControlModel ? { control: this.header } : { grid: this.header },
                        subwayMap: { control: this.subwayMap },
                        footer: { grid: this.footer },
                        title: this.title
                    },
                    _b),
                moduleKeys: !lodash_1.isNil(this.moduleKeys) ? this.moduleKeys : []
            },
            _a;
        var _a, _b;
    };
    return FormLayoutModel;
}(readable_node_1.ReadableNode));
exports.FormLayoutModel = FormLayoutModel;
//# sourceMappingURL=form-layout-model.js.map